import { allowedClassesFor } from "@circleco/compass/helpers/allowedClassesFor";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

// Valid HTML elements that Compass Typography can render
export type TypographyElement =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "span"
  | "div"
  | "code"
  | "label"
  | "legend";

export const useTypographyFlag = () =>
  useIsCircleV4FeatureEnabled("circle_v4_typography_enabled");

export const filterClassName = (className?: string) =>
  className ? allowedClassesFor("Typography", className) : undefined;

const UIKIT_ONLY_PROPS = new Set([
  "weight",
  "tracking",
  "size",
  "leading",
  "textAlign",
  "textTransform",
]);

export const stripUIKitProps = (rest: Record<string, unknown>) => {
  const keys = Object.keys(rest);
  if (keys.every(key => !UIKIT_ONLY_PROPS.has(key))) return rest;
  return Object.fromEntries(
    Object.entries(rest).filter(([key]) => !UIKIT_ONLY_PROPS.has(key)),
  );
};
